import type {
  ConsoleImpersonateResponse,
  ConsoleTenantCreateResponse,
  ConsoleTenantDetail,
  ConsoleTenantHealthRow,
  ConsoleTenantListItem,
  ConsoleTenantUpdateResponse,
  ResendVerificationResponse,
} from "@redipos/contracts";
import { http } from "../../shared/http.js";

/** Desalineación entre el plan de un cliente y los módulos que tiene activados. */
export interface ModuleDriftRow {
  tenantId: string;
  tenantName: string;
  module: string;
  label: string;
  kind: "incluido_sin_activar" | "activo_sin_plan";
  apagadoExplicito: boolean;
}

export const operacionesApi = {
  moduleDrift: () => http.get<ModuleDriftRow[]>("/admin/operaciones/modules/drift"),
  tenants: () => http.get<ConsoleTenantListItem[]>("/admin/operaciones/tenants"),
  createTenant: (body: { organizationName: string; email: string; phone: string }) =>
    http.post<ConsoleTenantCreateResponse>("/admin/operaciones/tenants", body),
  tenantHealth: (categoria?: string) =>
    http.get<ConsoleTenantHealthRow[]>(
      `/admin/operaciones/tenant-health${categoria ? `?categoria=${encodeURIComponent(categoria)}` : ""}`,
    ),
  tenant: (id: string) => http.get<ConsoleTenantDetail>(`/admin/operaciones/tenants/${encodeURIComponent(id)}`),
  tenantHealthOne: (id: string) =>
    http.get<ConsoleTenantHealthRow>(`/admin/operaciones/tenants/${encodeURIComponent(id)}/health`),
  updateTenant: (id: string, body: unknown) =>
    http.put<ConsoleTenantUpdateResponse>(`/admin/operaciones/tenants/${encodeURIComponent(id)}`, body),
  moduleStatus: (id: string, module: string) =>
    http.get<{ enabled: boolean; config: unknown }>(`/admin/operaciones/tenants/${encodeURIComponent(id)}/modules/${encodeURIComponent(module)}`),
  setModuleStatus: (id: string, module: string, enabled: boolean) =>
    http.put<{ enabled: boolean; config: unknown }>(`/admin/operaciones/tenants/${encodeURIComponent(id)}/modules/${encodeURIComponent(module)}`, { enabled }),
  impersonate: (id: string) =>
    http.post<ConsoleImpersonateResponse>(`/admin/operaciones/tenants/${encodeURIComponent(id)}/impersonate`, {}),
  resendUserVerification: (tenantId: string, userId: string) =>
    http.post<ResendVerificationResponse>(
      `/admin/operaciones/tenants/${encodeURIComponent(tenantId)}/users/${encodeURIComponent(userId)}/resend-verification`,
      {},
    ),
};
